export default "__VITE_ASSET__CiQYoHjT__"